module.exports = __webpack_public_path__ + "static/media/dew_point.0e206149.ico";